import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  LIST,
  GET,
  UPDATE,
  REMOVE,
  CREATE,
} from './action-types';
import {
  list,
  reset,
  requestFailed,
  listSucceeded,
  getSucceeded,
  updateSucceeded,
  removeSucceeded,
  createSucceeded,
} from './actions';

import { tokenSelector } from '../login/selectors';

function* listCollaboratingCenters() {
  const token = yield select(tokenSelector);
  try {
    const data = yield call(api.collaboratingCenter.getAll, { token });
    yield put(listSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* getCollaboratingCenter(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const data = yield call(api.collaboratingCenter.get, { token, id });
    yield put(getSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* updateCollaboratingCenter(action) {
  const token = yield select(tokenSelector);
  const { id, data } = action;
  try {
    const success = yield call(api.collaboratingCenter.update, { token, id, data });
    yield put(updateSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* removeCollaboratingCenter(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const success = yield call(api.collaboratingCenter.delete, { token, id });
    yield put(removeSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* createCollaboratingCenter(action) {
  const token = yield select(tokenSelector);
  const { data } = action;
  try {
    const success = yield call(api.collaboratingCenter.create, { token, data });
    yield put(createSucceeded(success));
    yield put(reset());
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

export default [
  takeEvery(LIST, listCollaboratingCenters),
  takeEvery(GET, getCollaboratingCenter),
  takeEvery(UPDATE, updateCollaboratingCenter),
  takeEvery(REMOVE, removeCollaboratingCenter),
  takeEvery(CREATE, createCollaboratingCenter),
];
